enum PeriodEnum {
	ONE_WEEK = '1W',
	ONE_MONTH = '1M',
	THREE_MONTHS = '3M',
	SIX_MONTHS = '6M',
	ONE_YEAR = '1Y',
}

export default PeriodEnum;
